import { createStore } from 'vuex';
import flight from './modules/flight';
import user from './modules/user';
import order from './modules/order';
import file from './modules/file';
import websocket from './modules/websocket';
import auth from './modules/auth';
import { isProduction } from '@/utils/envUtils';

const API_PREFIX = isProduction() ? '/api' : '/dev';
const baseURL = ''

const store = createStore({
    modules: {
        flight,
        user,
        file,
        websocket,
        order,
        auth
    },
    state: {
        API_PREFIX,
        baseURL,
        ip: ''
    },
    mutations: {
        setIp(state, newIp) {
            state.ip = newIp;
        },
        removeIp(state) {
            state.ip = '';
        }
    },
    actions: {
        updateIp({ commit }, newIp) {
            commit('setIp', newIp);
        },
        removeIp({ commit }) {
            commit('removeIp');
        }
    },
    getters: {
        getAPI_PREFIX(state) {
            return state.API_PREFIX;
        },
        getBaseURL(state) {
            return state.baseURL;
        },
        getIp(state) {
            return state.ip;
        }
    },
});

export default store;